import { BaseViewStore } from 'core/stores';
import { ChangeWarehouseShipByDateForm } from 'modules/order/forms';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { action } from 'mobx';
import { sourceOfChange } from 'common/constants';
import { notificationError } from 'core/utils';
import moment from 'moment';

class ChangeWarehouseShipByDateViewStore extends BaseViewStore {
	form = new ChangeWarehouseShipByDateForm({
		onSuccess: () => {
			this.changeWarehouseShipByDate();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		this.modalParams = modalParams;
		const locale = window.navigator.userLanguage || window.navigator.language;
		moment.locale(locale);
		const localeData = moment.localeData();
		this.datePickerFormat = localeData.longDateFormat('L');
		this.store = new FulfillmentOrderStore(rootStore);
	}

	@action.bound
	changeWarehouseShipByDate = async () => {
		this.suspend();
		try {
			const { warehouseShipByDate } = this.form.values();
			const payload = {
				ids: this.modalParams.data.map(item => {
					return item.id;
				}),
				warehouseShipByDate,
				dateFormat: this.datePickerFormat.toLowerCase().replaceAll('m','M'),
			};
			const result = await this.store.changeWarehouseShipByDate(payload, sourceOfChange.changeWarehouseShipByDate);
			if (result != 0) {
				this.rootStore.notificationStore.success(['CHANGEWAREHOUSESHIPBYDATE.NOTIFICATION.SUCCESS', { count: result }]);
			} else {
				this.rootStore.notificationStore.error('CHANGEWAREHOUSESHIPBYDATE.NOTIFICATION.FAILED');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};
}

export default ChangeWarehouseShipByDateViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/ChangeWarehouseShipByDateViewStore.js